import lottie from "lottie-web";

/**
 * lottie 이벤트 실행 함수
 * @param {string} id: document Id
 * @param {string} path: svg, canvas file path
 * @param {string} renderer:  'svg' (default) / 'canvas' / 'html' to set the renderer
 * @param {boolean} loop: true / false  (default) / number
 * @param {boolean} autoplay: true (default) / false  즉시 시작
 */
export default function lottieEventListener ({
  id,
  path,
  renderer = 'svg',
  loop = false,
  autoplay = true,
}) {
  const dom = document.getElementById(id);
  const data = {
    container: dom,
    path: `${process.env.PUBLIC_URL}${path}`,
    renderer,
    loop,
    autoplay,
  };

  lottie.loadAnimation(data);
}